import { useNavigate } from "react-router-dom";
import { Check, Crown, Lock } from "lucide-react";
import { Dialog, DialogContent, DialogDescription, DialogTitle } from "@/components/ui/dialog";

const PERKS = ["Every AETRYX Original & full series", "HD quality · up to 5 profiles", "4K and early Live access on Premium+"];

export const UpgradeModal = ({ open, title, onOpenChange }) => {
  const navigate = useNavigate();
  const go = () => { onOpenChange(false); navigate("/pricing"); };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="upgrade-modal" className="max-w-md overflow-hidden border border-[#D4AF37]/40 bg-[#050505] p-0 text-white shadow-[0_0_80px_rgba(212,175,55,0.18)]">
        <div className="relative h-40 overflow-hidden">
          {title?.backdrop_url && <img src={title.backdrop_url} alt="" className="absolute inset-0 h-full w-full object-cover opacity-50" />}
          <div className="absolute inset-0 bg-gradient-to-t from-[#050505] via-[#050505]/60 to-transparent" />
          <span className="absolute left-1/2 top-1/2 grid h-16 w-16 -translate-x-1/2 -translate-y-1/2 place-items-center rounded-full border border-[#FFD86A]/70 bg-black/70 text-[#FFD86A] shadow-[0_0_40px_rgba(212,175,55,0.45)]">
            <Lock className="h-7 w-7" />
          </span>
        </div>
        <div className="px-7 pb-7 -mt-2 text-center">
          <p className="eyebrow flex items-center justify-center gap-2"><Crown className="h-3.5 w-3.5" /> Premium</p>
          <DialogTitle className="mt-2 font-display text-3xl font-bold gold-text">Upgrade to watch</DialogTitle>
          <DialogDescription className="mt-3 text-sm text-white/70">
            {title?.title ? <><span className="text-[#FFD86A]">{title.title}</span> is part of the full AETRYX catalog.</> : "This title is part of the full AETRYX catalog."} Unlock it with the Creator plan.
          </DialogDescription>
          <ul className="mt-5 space-y-2 text-left text-sm">
            {PERKS.map((p) => <li key={p} className="flex items-center gap-2 text-white/80"><Check className="h-4 w-4 flex-none text-[#D4AF37]" /> {p}</li>)}
          </ul>
          <div className="mt-7 flex flex-col gap-3">
            <button data-testid="upgrade-modal-plans-btn" onClick={go} className="btn-gold py-3 text-sm">See plans · from $14.99/mo</button>
            <button data-testid="upgrade-modal-close-btn" onClick={() => onOpenChange(false)} className="text-sm text-[#8B8B8B] hover:text-white transition-colors">Not now</button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
